import facebookNewLogoUrl from 'assets/images/facebookNew.svg';
import instagramNewLogoUrl from 'assets/images/instagramNew.svg';
import linkedInLogoUrl from 'assets/images/linkedInNew.svg';
import messengerNewLogoUrl from 'assets/images/messengerNew.svg';
import { JobFacebookPlacement } from 'lib/enum/job-facebook-placement.enum';
import { JobInstagramPlacement } from 'lib/enum/job-instagram-placement.enum';
import { JobLinkedinPlacement } from 'lib/enum/job-linkedin-placement.enum';
import { JobMessengerPlacement } from 'lib/enum/job-messenger-placement.enum';
import { JobsChannel } from './jobs-channel.enum';

export enum JobPlatformType {
    Facebook = 'facebook',
    Instagram = 'instagram',
    Messenger = 'messenger',
    Linkedin = 'linkedin',
}

export const getJobPlacementEnumByPlatformType = (
    platformType: JobPlatformType,
):
    | typeof JobFacebookPlacement
    | typeof JobInstagramPlacement
    | typeof JobMessengerPlacement
    | typeof JobLinkedinPlacement => {
    switch (platformType) {
        case JobPlatformType.Facebook:
            return JobFacebookPlacement;
        case JobPlatformType.Instagram:
            return JobInstagramPlacement;
        case JobPlatformType.Messenger:
            return JobMessengerPlacement;
        case JobPlatformType.Linkedin:
            return JobLinkedinPlacement;
    }
};

export const getJobPlatformTypeDisplayName = (platformType: JobPlatformType): string => {
    switch (platformType) {
        case JobPlatformType.Facebook:
            return 'Facebook';
        case JobPlatformType.Instagram:
            return 'Instagram';
        case JobPlatformType.Messenger:
            return 'Messenger';
        case JobPlatformType.Linkedin:
            return 'Linkedin';
    }
};

export const getJobPlatformTypeLogo = (platformType: JobPlatformType): string => {
    switch (platformType) {
        case JobPlatformType.Facebook:
            return facebookNewLogoUrl;
        case JobPlatformType.Instagram:
            return instagramNewLogoUrl;
        case JobPlatformType.Messenger:
            return messengerNewLogoUrl;
        case JobPlatformType.Linkedin:
            return linkedInLogoUrl;
    }
};

const ChannelToJobPlatformsTypesMap = new Map<JobsChannel, JobPlatformType[]>([
    [JobsChannel.MetaMarketing, [JobPlatformType.Facebook, JobPlatformType.Instagram, JobPlatformType.Messenger]],
    [JobsChannel.LinkedinMarketing, [JobPlatformType.Linkedin]],
]);

export const getAvailablePlatformsTypesByChannels = (channels: JobsChannel[]): JobPlatformType[] =>
    channels.map(channel => ChannelToJobPlatformsTypesMap.get(channel) || []).flat();

export const getChannelByPlatformType = (platformType: JobPlatformType): JobsChannel => {
    for (let [channel, platforms] of Array.from(ChannelToJobPlatformsTypesMap.entries())) {
        if (platforms.includes(platformType)) {
            return channel;
        }
    }

    throw Error(`Not found channel by platform type: ${platformType}`);
};
